import { makeApiCall } from "../apirequest";

export default ({
  state: {
    brokers: [],
    brokerOrganization: [],  
    brokerPaymentHistory: [],  
  },
  getters: {
    getBrokers: (state) => state.brokers,
    getBrokerOrganization: (state) => state.brokerOrganization,
    getBrokerPaymentHistory: (state) => state.brokerPaymentHistory,
  },
  mutations: {
    SET_BROKERS(state, brokers) {
      state.brokers = brokers;
    },
    SET_BROKER_ORGANIZATION(state, brokerOrganization) {
      state.brokerOrganization = brokerOrganization;
    },
    SET_BROKER_PAYMENT_HISTORY(state, brokerPaymentHistory) {
      state.brokerPaymentHistory = brokerPaymentHistory;
    },
  },
  actions: {
    async getBrokers({ commit }, payload) {
      const response = await makeApiCall('Admin/GetUsersForAdmin', 'POST', payload);
      if (!response.error) {
        commit('SET_BROKERS', response.data.data);
      }
      return response;
    },
    async getBrokerOrganization({ commit }, payload) {
      const response = await makeApiCall('Admin/GetUserOfOrganization', 'POST', payload);
      if (!response.error) {
        commit('SET_BROKER_ORGANIZATION', response.data.data);
      }
      return response;
    },
    async getBrokerPaymentHistory({ commit }, payload) {
      const response = await makeApiCall(`User/GetUserSubcriptionDetail?UserId=${payload.UserId}`, 'POST');
      if (!response.error) {
        commit('SET_BROKER_PAYMENT_HISTORY', response.data.data);
      }
      return response;
    },
  },
})
